module.exports = __webpack_public_path__ + "img/bcorp.b9466d7a.png";